import { GlobalStore } from '@highlight/ipc'

/**
 * Written by Highlight 1.0, and by 2.0 builds predating open beta (9/4/2026).
 * It records that a user onboarded, never which app onboarded them, so it
 * cannot stand in for having completed 2.0 onboarding.
 *
 * Don't use this for new code.
 */
export const LEGACY_ONBOARDED_FLAG = 'onboarded'

export const ONBOARDING_COMPLETE_FLAG = 'onboarding-complete'

/** Where the onboarding window left off, so an abandoned run resumes there. General store. */
export const ONBOARDING_WINDOW_STEP_STORE_KEY = 'onboarding.windowStep'

/**
 * Set when the flow finishes on this machine and cleared once the server has
 * the 2.0 marker. While it is set, a null marker from the server means the
 * stamp has not landed yet, not that the user still owes a 2.0 run.
 */
export const ONBOARDING_SERVER_STAMP_PENDING = 'onboarding-server-stamp-pending'

/** Epoch ms when the user completed onboarding, or 0 while it's still in progress. */
export function getOnboardingCompletedAt(): number {
  return GlobalStore.user().get<number>(ONBOARDING_COMPLETE_FLAG, 0)
}

export function isOnboardingComplete(): boolean {
  return getOnboardingCompletedAt() > 0
}

/**
 * `completedAt` is not decoration: the value is read as a real instant, and a
 * meeting detected within ONBOARDING_IN_CALL_GRACE_MS of it is treated as one
 * the user was already in during onboarding, so autopilot skips it. Anything
 * restoring a past completion must pass that instant rather than now.
 */
export function setOnboardingComplete(completedAt: number = Date.now()): void {
  GlobalStore.user().set(ONBOARDING_COMPLETE_FLAG, completedAt)
}

export function resetOnboardingComplete(): void {
  GlobalStore.user().delete(ONBOARDING_COMPLETE_FLAG)
  GlobalStore.user().delete(LEGACY_ONBOARDED_FLAG)
  clearServerStampPending()
}

export function isServerStampPending(): boolean {
  return GlobalStore.user().get<boolean>(ONBOARDING_SERVER_STAMP_PENDING, false)
}

export function setServerStampPending(): void {
  GlobalStore.user().set(ONBOARDING_SERVER_STAMP_PENDING, true)
}

export function clearServerStampPending(): void {
  GlobalStore.user().delete(ONBOARDING_SERVER_STAMP_PENDING)
}
